export default __webpack_public_path__ + "static/media/oliver_white.b0bb39a9.svg";